import { Group, Radio } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";

interface RadioOption {
  value: string;
  label: string;
}

interface RadioGroupProps<T> {
  fieldName: string;
  label: string;
  options: RadioOption[];
  form: UseFormReturnType<T>;
  disabled?: boolean;
  required?: boolean;
}

const RadioGroup = <T,>(props: RadioGroupProps<T>) => {
  const { form, fieldName, label, options, disabled, required = true } = props;

  return (
    <Radio.Group
      label={label}
      key={form.key(fieldName)}
      {...form.getInputProps(fieldName)}
      required={required}
      withAsterisk={required}
    >
      <Group mt="xs">
        {options.map((option) => (
          <Radio key={option.value} value={option.value} label={option.label} disabled={disabled} />
        ))}
      </Group>
    </Radio.Group>
  );
};

export default RadioGroup;
